<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7521_6502)">
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.5425 9.48305C11.5425 7.02115 13.5382 5.02539 16.0001 5.02539C18.462 5.02539 20.4578 7.02115 20.4578 9.48305V17.5757H11.5425V9.48305ZM16.0001 7.02539C14.6428 7.02539 13.5425 8.12572 13.5425 9.48305V15.5757H18.4578V9.48305C18.4578 8.12572 17.3575 7.02539 16.0001 7.02539Z"
            fill="#754A47"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.5425 9.48305C11.5425 7.02115 13.5382 5.02539 16.0001 5.02539C18.462 5.02539 20.4578 7.02115 20.4578 9.48305V17.5757H11.5425V9.48305ZM16.0001 7.02539C14.6428 7.02539 13.5425 8.12572 13.5425 9.48305V15.5757H18.4578V9.48305C18.4578 8.12572 17.3575 7.02539 16.0001 7.02539Z"
            fill="url(#paint0_radial_7521_6502)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.5425 9.48305C11.5425 7.02115 13.5382 5.02539 16.0001 5.02539C18.462 5.02539 20.4578 7.02115 20.4578 9.48305V17.5757H11.5425V9.48305ZM16.0001 7.02539C14.6428 7.02539 13.5425 8.12572 13.5425 9.48305V15.5757H18.4578V9.48305C18.4578 8.12572 17.3575 7.02539 16.0001 7.02539Z"
            fill="url(#paint1_radial_7521_6502)"
            fill-opacity="0.87"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.5425 9.48305C11.5425 7.02115 13.5382 5.02539 16.0001 5.02539C18.462 5.02539 20.4578 7.02115 20.4578 9.48305V17.5757H11.5425V9.48305ZM16.0001 7.02539C14.6428 7.02539 13.5425 8.12572 13.5425 9.48305V15.5757H18.4578V9.48305C18.4578 8.12572 17.3575 7.02539 16.0001 7.02539Z"
            fill="url(#paint2_radial_7521_6502)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.5425 9.48305C11.5425 7.02115 13.5382 5.02539 16.0001 5.02539C18.462 5.02539 20.4578 7.02115 20.4578 9.48305V17.5757H11.5425V9.48305ZM16.0001 7.02539C14.6428 7.02539 13.5425 8.12572 13.5425 9.48305V15.5757H18.4578V9.48305C18.4578 8.12572 17.3575 7.02539 16.0001 7.02539Z"
            fill="url(#paint3_radial_7521_6502)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.5425 9.48305C11.5425 7.02115 13.5382 5.02539 16.0001 5.02539C18.462 5.02539 20.4578 7.02115 20.4578 9.48305V17.5757H11.5425V9.48305ZM16.0001 7.02539C14.6428 7.02539 13.5425 8.12572 13.5425 9.48305V15.5757H18.4578V9.48305C18.4578 8.12572 17.3575 7.02539 16.0001 7.02539Z"
            fill="url(#paint4_radial_7521_6502)"
            fill-opacity="0.6"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.5425 9.48305C11.5425 7.02115 13.5382 5.02539 16.0001 5.02539C18.462 5.02539 20.4578 7.02115 20.4578 9.48305V17.5757H11.5425V9.48305ZM16.0001 7.02539C14.6428 7.02539 13.5425 8.12572 13.5425 9.48305V15.5757H18.4578V9.48305C18.4578 8.12572 17.3575 7.02539 16.0001 7.02539Z"
            fill="url(#paint5_radial_7521_6502)"
            fill-opacity="0.72"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.5425 9.48305C11.5425 7.02115 13.5382 5.02539 16.0001 5.02539C18.462 5.02539 20.4578 7.02115 20.4578 9.48305V17.5757H11.5425V9.48305ZM16.0001 7.02539C14.6428 7.02539 13.5425 8.12572 13.5425 9.48305V15.5757H18.4578V9.48305C18.4578 8.12572 17.3575 7.02539 16.0001 7.02539Z"
            fill="url(#paint6_radial_7521_6502)"
      />
      <path d="M2.05127 14.0542C2.05127 12.9496 2.9467 12.0542 4.05127 12.0542H27.949C29.0536 12.0542 29.949 12.9496 29.949 14.0542V27.9631C29.949 29.0677 29.0536 29.9631 27.949 29.9631H4.05127C2.9467 29.9631 2.05127 29.0677 2.05127 27.9631V14.0542Z"
            fill="url(#paint7_linear_7521_6502)"
      />
      <path d="M2.05127 14.0542C2.05127 12.9496 2.9467 12.0542 4.05127 12.0542H27.949C29.0536 12.0542 29.949 12.9496 29.949 14.0542V27.9631C29.949 29.0677 29.0536 29.9631 27.949 29.9631H4.05127C2.9467 29.9631 2.05127 29.0677 2.05127 27.9631V14.0542Z"
            fill="url(#paint8_linear_7521_6502)"
      />
      <path d="M2.05127 14.0542C2.05127 12.9496 2.9467 12.0542 4.05127 12.0542H27.949C29.0536 12.0542 29.949 12.9496 29.949 14.0542V27.9631C29.949 29.0677 29.0536 29.9631 27.949 29.9631H4.05127C2.9467 29.9631 2.05127 29.0677 2.05127 27.9631V14.0542Z"
            fill="url(#paint9_radial_7521_6502)"
      />
      <path d="M2.05127 14.0542C2.05127 12.9496 2.9467 12.0542 4.05127 12.0542H27.949C29.0536 12.0542 29.949 12.9496 29.949 14.0542V27.9631C29.949 29.0677 29.0536 29.9631 27.949 29.9631H4.05127C2.9467 29.9631 2.05127 29.0677 2.05127 27.9631V14.0542Z"
            fill="url(#paint10_radial_7521_6502)"
      />
      <path d="M2.05127 14.0542C2.05127 12.9496 2.9467 12.0542 4.05127 12.0542H27.949C29.0536 12.0542 29.949 12.9496 29.949 14.0542V27.9631C29.949 29.0677 29.0536 29.9631 27.949 29.9631H4.05127C2.9467 29.9631 2.05127 29.0677 2.05127 27.9631V14.0542Z"
            fill="url(#paint11_linear_7521_6502)"
      />
      <path d="M2.05127 14.0542C2.05127 12.9496 2.9467 12.0542 4.05127 12.0542H27.949C29.0536 12.0542 29.949 12.9496 29.949 14.0542V27.9631C29.949 29.0677 29.0536 29.9631 27.949 29.9631H4.05127C2.9467 29.9631 2.05127 29.0677 2.05127 27.9631V14.0542Z"
            fill="url(#paint12_linear_7521_6502)"
      />
      <path d="M2.05127 14.0542C2.05127 12.9496 2.9467 12.0542 4.05127 12.0542H27.949C29.0536 12.0542 29.949 12.9496 29.949 14.0542V27.9631C29.949 29.0677 29.0536 29.9631 27.949 29.9631H4.05127C2.9467 29.9631 2.05127 29.0677 2.05127 27.9631V14.0542Z"
            fill="url(#paint13_linear_7521_6502)"
      />
      <path d="M2.05127 14.0542C2.05127 12.9496 2.9467 12.0542 4.05127 12.0542H27.949C29.0536 12.0542 29.949 12.9496 29.949 14.0542V27.9631C29.949 29.0677 29.0536 29.9631 27.949 29.9631H4.05127C2.9467 29.9631 2.05127 29.0677 2.05127 27.9631V14.0542Z"
            fill="url(#paint14_linear_7521_6502)"
      />
      <path d="M2.05127 14.0542C2.05127 12.9496 2.9467 12.0542 4.05127 12.0542H27.949C29.0536 12.0542 29.949 12.9496 29.949 14.0542V27.9631C29.949 29.0677 29.0536 29.9631 27.949 29.9631H4.05127C2.9467 29.9631 2.05127 29.0677 2.05127 27.9631V14.0542Z"
            fill="url(#paint15_linear_7521_6502)"
      />
      <path d="M2.05127 14.0542C2.05127 12.9496 2.9467 12.0542 4.05127 12.0542H27.949C29.0536 12.0542 29.949 12.9496 29.949 14.0542V27.9631C29.949 29.0677 29.0536 29.9631 27.949 29.9631H4.05127C2.9467 29.9631 2.05127 29.0677 2.05127 27.9631V14.0542Z"
            fill="url(#paint16_linear_7521_6502)"
      />
      <path d="M2.05127 14.0542C2.05127 12.9496 2.9467 12.0542 4.05127 12.0542H27.949C29.0536 12.0542 29.949 12.9496 29.949 14.0542V27.9631C29.949 29.0677 29.0536 29.9631 27.949 29.9631H4.05127C2.9467 29.9631 2.05127 29.0677 2.05127 27.9631V14.0542Z"
            fill="url(#paint17_linear_7521_6502)"
      />
      <path d="M2.05127 14.0542C2.05127 12.9496 2.9467 12.0542 4.05127 12.0542H27.949C29.0536 12.0542 29.949 12.9496 29.949 14.0542V27.9631C29.949 29.0677 29.0536 29.9631 27.949 29.9631H4.05127C2.9467 29.9631 2.05127 29.0677 2.05127 27.9631V14.0542Z"
            fill="url(#paint18_linear_7521_6502)"
      />
      <path d="M2.05127 14.0542C2.05127 12.9496 2.9467 12.0542 4.05127 12.0542H27.949C29.0536 12.0542 29.949 12.9496 29.949 14.0542V27.9631C29.949 29.0677 29.0536 29.9631 27.949 29.9631H4.05127C2.9467 29.9631 2.05127 29.0677 2.05127 27.9631V14.0542Z"
            fill="url(#paint19_radial_7521_6502)"
      />
      <path d="M2.05127 14.0542C2.05127 12.9496 2.9467 12.0542 4.05127 12.0542H27.949C29.0536 12.0542 29.949 12.9496 29.949 14.0542V27.9631C29.949 29.0677 29.0536 29.9631 27.949 29.9631H4.05127C2.9467 29.9631 2.05127 29.0677 2.05127 27.9631V14.0542Z"
            fill="url(#paint20_radial_7521_6502)"
      />
      <path d="M2.05127 14.0542C2.05127 12.9496 2.9467 12.0542 4.05127 12.0542H27.949C29.0536 12.0542 29.949 12.9496 29.949 14.0542V27.9631C29.949 29.0677 29.0536 29.9631 27.949 29.9631H4.05127C2.9467 29.9631 2.05127 29.0677 2.05127 27.9631V14.0542Z"
            fill="url(#paint21_radial_7521_6502)"
      />
      <path d="M2.05127 11.0103C2.05127 9.90569 2.9467 9.01025 4.05127 9.01025H27.949C29.0536 9.01025 29.949 9.90568 29.949 11.0103V15.4695C29.949 17.4025 28.382 18.9695 26.449 18.9695H5.55127C3.61828 18.9695 2.05127 17.4025 2.05127 15.4695V11.0103Z"
            fill="url(#paint22_linear_7521_6502)"
      />
      <path d="M2.05127 11.0103C2.05127 9.90569 2.9467 9.01025 4.05127 9.01025H27.949C29.0536 9.01025 29.949 9.90568 29.949 11.0103V15.4695C29.949 17.4025 28.382 18.9695 26.449 18.9695H5.55127C3.61828 18.9695 2.05127 17.4025 2.05127 15.4695V11.0103Z"
            fill="url(#paint23_linear_7521_6502)"
      />
      <path d="M2.05127 11.0103C2.05127 9.90569 2.9467 9.01025 4.05127 9.01025H27.949C29.0536 9.01025 29.949 9.90568 29.949 11.0103V15.4695C29.949 17.4025 28.382 18.9695 26.449 18.9695H5.55127C3.61828 18.9695 2.05127 17.4025 2.05127 15.4695V11.0103Z"
            fill="url(#paint24_linear_7521_6502)"
      />
      <path d="M2.05127 11.0103C2.05127 9.90569 2.9467 9.01025 4.05127 9.01025H27.949C29.0536 9.01025 29.949 9.90568 29.949 11.0103V15.4695C29.949 17.4025 28.382 18.9695 26.449 18.9695H5.55127C3.61828 18.9695 2.05127 17.4025 2.05127 15.4695V11.0103Z"
            fill="url(#paint25_linear_7521_6502)"
      />
      <path d="M2.05127 11.0103C2.05127 9.90569 2.9467 9.01025 4.05127 9.01025H27.949C29.0536 9.01025 29.949 9.90568 29.949 11.0103V15.4695C29.949 17.4025 28.382 18.9695 26.449 18.9695H5.55127C3.61828 18.9695 2.05127 17.4025 2.05127 15.4695V11.0103Z"
            fill="url(#paint26_linear_7521_6502)"
      />
      <path d="M2.05127 11.0103C2.05127 9.90569 2.9467 9.01025 4.05127 9.01025H27.949C29.0536 9.01025 29.949 9.90568 29.949 11.0103V15.4695C29.949 17.4025 28.382 18.9695 26.449 18.9695H5.55127C3.61828 18.9695 2.05127 17.4025 2.05127 15.4695V11.0103Z"
            fill="url(#paint27_radial_7521_6502)"
      />
      <rect x="12.749"
            y="17.0488"
            width="6.50157"
            height="4.90574"
            rx="1"
            fill="url(#paint28_linear_7521_6502)"
      />
      <rect x="12.749"
            y="17.0488"
            width="6.50157"
            height="4.90574"
            rx="1"
            fill="url(#paint29_linear_7521_6502)"
      />
      <rect x="12.749"
            y="17.0488"
            width="6.50157"
            height="4.90574"
            rx="1"
            fill="url(#paint30_linear_7521_6502)"
      />
      <rect x="12.749"
            y="17.0488"
            width="6.50157"
            height="4.90574"
            rx="1"
            fill="url(#paint31_radial_7521_6502)"
      />
      <rect x="12.749"
            y="17.0488"
            width="6.50157"
            height="4.90574"
            rx="1"
            fill="url(#paint32_radial_7521_6502)"
      />
      <rect x="12.749"
            y="17.0488"
            width="6.50157"
            height="4.90574"
            rx="1"
            fill="url(#paint33_linear_7521_6502)"
      />
      <rect x="12.749"
            y="17.0488"
            width="6.50157"
            height="4.90574"
            rx="1"
            fill="url(#paint34_radial_7521_6502)"
      />
      <rect x="12.749"
            y="17.0488"
            width="6.50157"
            height="4.90574"
            rx="1"
            fill="url(#paint35_linear_7521_6502)"
      />
      <rect x="12.749"
            y="17.0488"
            width="6.50157"
            height="4.90574"
            rx="1"
            fill="url(#paint36_linear_7521_6502)"
      />
      <path d="M19.2506 18.9698H12.749V18.0488C12.749 17.4966 13.1967 17.0488 13.749 17.0488H18.2506C18.8029 17.0488 19.2506 17.4966 19.2506 18.0488V18.9698Z"
            fill="url(#paint37_linear_7521_6502)"
      />
      <path d="M19.2506 18.9698H12.749V18.0488C12.749 17.4966 13.1967 17.0488 13.749 17.0488H18.2506C18.8029 17.0488 19.2506 17.4966 19.2506 18.0488V18.9698Z"
            fill="url(#paint38_linear_7521_6502)"
      />
    </g>
    <defs>
      <radialGradient id="paint0_radial_7521_6502"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.3038 9.30593) rotate(101.293) scale(3.26167 2.64568)"
      >
        <stop offset="0.645833"
              stop-color="#77425B"
        />
        <stop offset="1"
              stop-color="#774256"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint1_radial_7521_6502"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.3038 9.30593) rotate(101.293) scale(3.26167 2.64568)"
      >
        <stop offset="0.546875"
              stop-color="#603C3A"
        />
        <stop offset="1"
              stop-color="#603C3A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint2_radial_7521_6502"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(10.7743 7.58852) rotate(107.475) scale(2.63071 1.68595)"
      >
        <stop offset="0.333333"
              stop-color="#77425C"
        />
        <stop offset="1"
              stop-color="#774256"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint3_radial_7521_6502"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(10.7743 7.58852) rotate(107.475) scale(2.63071 1.68595)"
      >
        <stop offset="0.333333"
              stop-color="#603C3A"
        />
        <stop offset="1"
              stop-color="#603C3A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint4_radial_7521_6502"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.0827 6.46098) rotate(124.287) scale(0.571789 1.17219)"
      >
        <stop stop-color="#98726F" />
        <stop offset="1"
              stop-color="#98726F"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint5_radial_7521_6502"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.2423 7.64205) rotate(135) scale(0.698483 1.90709)"
      >
        <stop stop-color="#98726F" />
        <stop offset="1"
              stop-color="#98726F"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint6_radial_7521_6502"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.5517 7.44878) rotate(-148.57) scale(0.452994 1.8588)"
      >
        <stop stop-color="#7D5952" />
        <stop offset="1"
              stop-color="#7D5952"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint7_linear_7521_6502"
                      x1="16.0001"
                      y1="19.7501"
                      x2="16.0001"
                      y2="29.6676"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#81505E" />
        <stop offset="1"
              stop-color="#754759"
        />
      </linearGradient>
      <linearGradient id="paint8_linear_7521_6502"
                      x1="16.0001"
                      y1="18.7522"
                      x2="16.0001"
                      y2="19.4437"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.151099"
              stop-color="#74394F"
        />
        <stop offset="1"
              stop-color="#74394F"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint9_radial_7521_6502"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(1.84902 20.2641) rotate(-7.96175) scale(3.39228)"
      >
        <stop offset="0.490139"
              stop-color="#81515F"
        />
        <stop offset="1"
              stop-color="#81515F"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint10_radial_7521_6502"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(30.4082 19.5007) rotate(177.013) scale(2.5991)"
      >
        <stop offset="0.490139"
              stop-color="#81515F"
        />
        <stop offset="1"
              stop-color="#81515F"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint11_linear_7521_6502"
                      x1="16.0001"
                      y1="30.0954"
                      x2="16.0001"
                      y2="29.3501"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#722E6C" />
        <stop offset="1"
              stop-color="#722E6C"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint12_linear_7521_6502"
                      x1="29.077"
                      y1="30.618"
                      x2="28.1782"
                      y2="29.5433"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#722E60" />
        <stop offset="1"
              stop-color="#722E6C"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint13_linear_7521_6502"
                      x1="30.4344"
                      y1="25.0261"
                      x2="29.6729"
                      y2="25.0261"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#722E60" />
        <stop offset="1"
              stop-color="#722E6C"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint14_linear_7521_6502"
                      x1="29.949"
                      y1="23.202"
                      x2="29.3473"
                      y2="23.202"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#946869" />
        <stop offset="1"
              stop-color="#946869"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint15_linear_7521_6502"
                      x1="29.8027"
                      y1="29.265"
                      x2="29.1653"
                      y2="28.7488"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#946869" />
        <stop offset="1"
              stop-color="#946869"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint16_linear_7521_6502"
                      x1="2.05127"
                      y1="22.7874"
                      x2="2.70576"
                      y2="22.7874"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#693A47" />
        <stop offset="1"
              stop-color="#693A47"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint17_linear_7521_6502"
                      x1="2.49219"
                      y1="29.5626"
                      x2="2.83984"
                      y2="28.879"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#693A3D" />
        <stop offset="1"
              stop-color="#693A47"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint18_linear_7521_6502"
                      x1="15.7444"
                      y1="29.9631"
                      x2="15.7444"
                      y2="29.4672"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#693A3D" />
        <stop offset="1"
              stop-color="#693A47"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint19_radial_7521_6502"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.4951 21.1923) rotate(88.3153) scale(1.33612)"
      >
        <stop offset="0.385489"
              stop-color="#70344D"
        />
        <stop offset="1"
              stop-color="#70344D"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint20_radial_7521_6502"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.7865 21.3025) rotate(80.0569) scale(1.23721 2.66691)"
      >
        <stop offset="0.4875"
              stop-color="#70344D"
        />
        <stop offset="1"
              stop-color="#70344D"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint21_radial_7521_6502"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.0971 19.6897) rotate(1.4688) scale(0.967699 2.08595)"
      >
        <stop offset="0.4875"
              stop-color="#70344D"
              stop-opacity="0.73"
        />
        <stop offset="1"
              stop-color="#70344D"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint22_linear_7521_6502"
                      x1="16.0001"
                      y1="9.01025"
                      x2="16.0001"
                      y2="18.9695"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#82525B" />
        <stop offset="1"
              stop-color="#714654"
        />
      </linearGradient>
      <linearGradient id="paint23_linear_7521_6502"
                      x1="16.0001"
                      y1="18.9695"
                      x2="16.0001"
                      y2="17.9155"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#632752" />
        <stop offset="0.667599"
              stop-color="#632752"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint24_linear_7521_6502"
                      x1="28.427"
                      y1="18.8295"
                      x2="27.6132"
                      y2="17.9679"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#632752" />
        <stop offset="1"
              stop-color="#632752"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint25_linear_7521_6502"
                      x1="3.05661"
                      y1="18.279"
                      x2="3.70283"
                      y2="17.3935"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#632752" />
        <stop offset="1"
              stop-color="#632752"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint26_linear_7521_6502"
                      x1="28.8065"
                      y1="18.387"
                      x2="28.2637"
                      y2="17.6189"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6A315C" />
        <stop offset="1"
              stop-color="#6A315C"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint27_radial_7521_6502"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.6591 18.6006) rotate(-40.3645) scale(1.72916)"
      >
        <stop offset="0.4875"
              stop-color="#683153"
        />
        <stop offset="1"
              stop-color="#693354"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint28_linear_7521_6502"
                      x1="15.9998"
                      y1="19.0628"
                      x2="15.9998"
                      y2="21.9546"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D38773" />
        <stop offset="1"
              stop-color="#D17A55"
        />
      </linearGradient>
      <linearGradient id="paint29_linear_7521_6502"
                      x1="19.2506"
                      y1="20.5001"
                      x2="19.006"
                      y2="20.5001"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DE987D" />
        <stop offset="1"
              stop-color="#DE987D"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint30_linear_7521_6502"
                      x1="16.8034"
                      y1="21.9546"
                      x2="16.8034"
                      y2="21.7723"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DE987D" />
        <stop offset="1"
              stop-color="#DE987D"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint31_radial_7521_6502"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.2758 22.1771) rotate(-35.8376) scale(0.921725 0.313629)"
      >
        <stop stop-color="#DE987D" />
        <stop offset="1"
              stop-color="#DE987D"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint32_radial_7521_6502"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.7739 22.0006) rotate(-58.344) scale(0.908312 0.309066)"
      >
        <stop stop-color="#DE987D" />
        <stop offset="1"
              stop-color="#DE987D"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint33_linear_7521_6502"
                      x1="12.749"
                      y1="19.9304"
                      x2="12.9983"
                      y2="19.9304"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CC685C" />
        <stop offset="1"
              stop-color="#CC685C"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint34_radial_7521_6502"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.1243 21.9546) rotate(-54.589) scale(0.483194 9.66034)"
      >
        <stop stop-color="#CC685C" />
        <stop offset="1"
              stop-color="#CC685C"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint35_linear_7521_6502"
                      x1="15.9998"
                      y1="18.7816"
                      x2="15.9998"
                      y2="19.2972"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.333334"
              stop-color="#6D311A"
        />
        <stop offset="1"
              stop-color="#C46E44"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint36_linear_7521_6502"
                      x1="15.9998"
                      y1="17.0488"
                      x2="15.9998"
                      y2="22.9944"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.711695"
              stop-color="#CA624F"
              stop-opacity="0"
        />
        <stop offset="0.873443"
              stop-color="#CA624F"
        />
      </linearGradient>
      <linearGradient id="paint37_linear_7521_6502"
                      x1="15.9998"
                      y1="18.0093"
                      x2="15.9998"
                      y2="18.9698"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D89577" />
        <stop offset="1"
              stop-color="#CB7368"
        />
      </linearGradient>
      <linearGradient id="paint38_linear_7521_6502"
                      x1="15.9998"
                      y1="17.0488"
                      x2="15.9998"
                      y2="17.2578"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E2A37B" />
        <stop offset="1"
              stop-color="#E2A37B"
              stop-opacity="0"
        />
      </linearGradient>
      <clipPath id="clip0_7521_6502">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
